import React, { useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { theme } from "../../../theme";
import { tableIcons } from "../../../table-icons";
import { Button, Grid } from "@material-ui/core";
import { GoalFilterDialog } from "./GoalFilterDialog";
import { getFilteredItems } from "../../utils/filter-utils";
import { GoalEditDialog } from "./GoalEditDialog";
import { CarePlansAPI } from "../../CarePlansAPI";
import { Goal } from "../../utils/fhir-utils/domain";

export function GoalList({ carePlan }) {
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [filter, setFilter] = useState({});
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState(null);

  if (!carePlan) {
    return null;
  }

  const goals = carePlan.getGoals();

  const onFilterSelected = (filter) => {
    setFilterDialogOpen(false);
    setFilter(filter);
  };

  const onSubmit = async (goal) => {
    if (goal.isNew()) {
      const newGoal = await CarePlansAPI.createCarePlanChild(goal);
      goal.addToCarePlan(newGoal);
    } else {
      await CarePlansAPI.updateResource(goal);
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <MaterialTable
          data={getFilteredItems(goals, filter)}
          icons={tableIcons}
          onRowClick={(_, goal) => {
            setSelectedGoal(goal);
            setEditDialogOpen(true);
          }}
          options={{
            emptyRowsWhenPaging: false,
            padding: "dense",
            pageSize: 10,
            search: true,
            sorting: true,
          }}
          columns={[
            {
              title: "Goal",
              render: (goal) => {
                return goal?.getDescription();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getDescription()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getDescription() <= g2.getDescription() ? -1 : 1;
              },
            },
            {
              title: "Status",
              render: (goal) => {
                return goal?.getStatus();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getStatus()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getStatus() <= g2.getStatus() ? -1 : 1;
              },
            },
            {
              title: "Category",
              render: (goal) => {
                return goal?.getCategory();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getCategory()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getCategory() <= g2.getCategory() ? -1 : 1;
              },
            },
            {
              title: "Due Date",
              render: (goal) => {
                return goal?.getDueDateMDYFromNow();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getDueDateMDY()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getDueDate() <= g2.getDueDate() ? -1 : 1;
              },
            },
            {
              title: "Description",
              render: (goal) => {
                return goal?.getDescription();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getDescription()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getDescription() <= g2.getDescription() ? -1 : 1;
              },
            },
            {
              title: "Comments",
              render: (goal) => {
                return goal?.getComments();
              },
              customFilterAndSearch: (filter, goal) => {
                return goal
                  ?.getComments()
                  ?.toUpperCase()
                  ?.includes(filter?.toUpperCase());
              },
              customSort: (g1, g2) => {
                return g1.getComments() <= g2.getComments() ? -1 : 1;
              },
            },
          ]}
          title={
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setSelectedGoal(new Goal(null, carePlan));
                    setEditDialogOpen(true);
                  }}
                >
                  Add a Goal
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setFilterDialogOpen(true);
                  }}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>
          }
        />
      </ThemeProvider>
      <GoalFilterDialog
        goals={goals}
        open={filterDialogOpen}
        onClose={() => {
          setFilterDialogOpen(false);
        }}
        onFilterSelected={onFilterSelected}
      />
      <GoalEditDialog
        goal={selectedGoal}
        open={editDialogOpen}
        onClose={() => {
          setEditDialogOpen(false);
        }}
        onSubmit={onSubmit}
      />
    </>
  );
}
